export const MS_OFFICE_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.ms-excel.addin.macroEnabled.12",
];

// Files supported by Document Intelligence.
export const DOCUMENT_INTELLIGENCE_FILE_TYPES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/tiff",
  "text/markdown",
  "text/*",
  "text/tab-separated-values",
  ...MS_OFFICE_MIME_TYPES,
] as const;

export const [PDF_FILE_MIME_TYPE] = DOCUMENT_INTELLIGENCE_FILE_TYPES;

// Plain text file extensions.
export const PLAIN_TEXT_EXTENSIONS = [
  ".c",
  ".cpp",
  ".csv",
  ".tsv",
  ".diff",
  ".htm",
  ".html",
  ".js",
  ".mjs",
  ".json",
  ".jsx",
  ".md",
  ".py",
  ".r",
  ".sql",
  ".ts",
  ".tsx",
  ".txt",
  ".xml",
  ".yaml",
  ".yml",
  ".xlf",
  ".xliff",
] as const;

export type PlainTextExtension = (typeof PLAIN_TEXT_EXTENSIONS)[number];

export type ProgrammingLanguageFileExtensions = Extract<
  PlainTextExtension,
  | ".c"
  | ".cpp"
  | ".js"
  | ".jsx"
  | ".ts"
  | ".tsx"
  | ".py"
  | ".r"
  | ".sql"
  | ".json"
  | ".htm"
  | ".html"
  | ".yaml"
  | ".yml"
>;

export const PLAIN_TEXT_TABLE_TYPES = {
  ".csv": "markdown",
  ".tsv": "markdown",
} as const;

export type PlainTextTableExtensions = keyof typeof PLAIN_TEXT_TABLE_TYPES;

export const PROGRAMMING_LANGUAGE_FILE_EXTENSIONS: Record<
  ProgrammingLanguageFileExtensions,
  string
> = {
  ".c": "c",
  ".cpp": "cpp",
  ".js": "javascript",
  ".jsx": "javascript",
  ".ts": "typescript",
  ".tsx": "typescript",
  ".py": "python",
  ".r": "r",
  ".sql": "sql",
  ".json": "json",
  ".htm": "cshtml",
  ".html": "cshtml",
  ".yaml": "yaml",
  ".yml": "yaml",
};

// Supported file types for upload.
export const SUPPORTED_FILE_TYPES = `Supported formats are: .pdf, .jpeg/.jpg, .png, .bmp, .tiff, .heif, .docx, .pptx, .html, .xlsx, ${PLAIN_TEXT_EXTENSIONS.join(", ")}`;

// Maximum file size for processing (400MB)
// Node.js V8 engine has a hard limit on string length of ~512MB (0x1fffffe8 characters).
// This prevents string length overflow errors when processing very large documents.
export const MAX_PROCESSABLE_FILE_SIZE_BYTES = 400 * 1024 * 1024; // 400MB
export const MAX_PROCESSABLE_FILE_SIZE_MB = 400;
